var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"usewater"}},[_c('div',{staticClass:"title"},[_vm._v("日用水量")]),_c('div',{ref:"myEcharts",attrs:{"id":"mydom"}})])}
var staticRenderFns = []

export { render, staticRenderFns }